
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a-realiza",
      function () {
        return require("private-next-pages/a-realiza/index.js");
      }
    ]);
  